<template>
  <div v-if="active" class="layer layerpopup" :data-type="popupType">
    <div ref="layerpopupInner" class="layerpopupInner">
      <VueSlickCarousel
        :autoplay="setting && setting.autoplay"
        :autoplaySpeed="4000"
        :arrows="false"
        :infinite="false"
        :dots="popup && popup.length > 1"
        :swipe="popup && popup.length > 1">
        <div v-for="(page, index) in popup"
          :key="index">
          <Page
            :id="page"
            :locale="locale"
            :lang="lang"
            :responsive="responsive"
            :translateType="translateType"
            :guestType="guestType"
            :roomKey="roomKey" />
        </div>
      </VueSlickCarousel>
      <div class="bottomBtns notranslate">
        <button type="button" class="btnCloseCookie" @click="closeCookie">{{closeWay === '1day' ? locale.layerpopup_close_1day : locale.layerpopup_close_ota}}</button>
        <button type="button" class="btnClose" @click="close">{{ locale.close }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel' // vue-carousel을 중첩으로 썼을 때 (gallery module) 가로 계산을 제대로 못하는 상황이 발생하여 팝업 프레임 자체는 다른 캐러셀 플러그인 사용
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import Page from '@/components/LayerPopup/Index.vue' // view/Page.vue가 store를 사용하기 때문에 모든 레이어페이지가 동일하게 뜨는 문제로 독립된 layerpopup page 분리
import moment from 'moment/moment'

export default {
  name: 'Layerpopup',
  props: [
    'locale',
    'lang',
    'responsive',
    'translateType',
    'guestType',
    'roomKey',
    'isPublic',
    'layerpopup',
    'site'
  ],
  components: {
    VueSlickCarousel,
    Page
  },
  computed: {
    setting () {
      return this.layerpopup.setting
    },
    popupType () {
      return this.setting.type
    },
    closeWay () {
      return this.setting.close
    }
  },
  created () {
    document.body.classList.add('layerOn')
    this.checkCookie()
    this.popup = this.layerpopup.popup.map(x => x)
  },
  mounted () {
    const setting = this.setting
    this.$nextTick(() => {
      if (setting && setting.type && setting.slideup) {
        this.slideup()
      }
    })
  },
  destroyed () {
    document.body.classList.remove('layerOn')
  },
  data () {
    return {
      active: false,
      slideupCnt: 0,
      autoplay: false,
      popup: [],
      pageCnt: 0,
      page404: []
    }
  },
  methods: {
    slideup () {
      const layerpopup = this.$refs.layerpopupInner
      if (layerpopup) {
        layerpopup.querySelector('.bottomBtns').style.display = 'none'
        let timerId = setInterval(() => {
          const remain = this.slideupCnt
          this.slideupCnt += 1
          layerpopup.style.transform = `translateY(${100 - (remain / 30 * 100)}%)`
          if (this.slideupCnt > 30) {
            clearInterval(timerId)
            layerpopup.style.transform = ''
            layerpopup.querySelector('.bottomBtns').style.display = ''
          }
        }, 20)
      }
    },
    async checkCookie () {
      const site = this.$store.state.authentication.site
      const key = this.isPublic ? await this.$store.dispatch('authentication/getOtaKey') : this.$store.state.authentication.k
      const invalidKey = key && key.message && key.message === 'fail'
      const id = this.layerpopup.id
      const popupKey = `layerpopup_${site}_${id}`
      const storage = JSON.parse(localStorage.getItem(popupKey))
      const way = this.closeWay
      const resetTimeString = this.setting.limitTime.split(':')
      const resetHh = resetTimeString[0]
      const resetMm = resetTimeString[1]
      if (this.setting.otaOnlyActive && invalidKey) {
        this.close()
      } else if (storage) {
        const resetTime = moment(storage.closeat).isBefore(moment().set({ hour: resetHh, minute: resetMm, second: 0 }))
          ? moment().set({ hour: resetHh, minute: resetMm, second: 0 })
          : moment().set({ hour: resetHh, minute: resetMm, second: 0 }).add(1, 'day')
        if ((storage.key === 'always' || way === '1day') && moment().isBefore(resetTime)) {
          // 1일닫기 또는 invalid ota로 다시보지않기일 때 매일 리셋시간 전까지 닫음
          this.close()
        } else if (way === 'stay' && storage.key === key) {
          // 다시보지않기일 때 ota 일치하면 새 ota가 덮어쓸 때까지 닫음
          this.close()
        } else {
          localStorage.removeItem(popupKey)
          this.active = true
        }
      } else {
        this.active = true
      }
    },
    closeCookie () {
      const site = this.$store.state.authentication.site
      const id = this.layerpopup.id
      const key = this.$store.state.authentication.k || 'always'
      const closeat = moment().toISOString()
      const popupKey = `layerpopup_${site}_${id}`
      const storageData = JSON.stringify({ key: key, closeat: closeat }) // expiredTime은 1일닫기 기준시각으로 저장 (다시보지않기일 때는 이 값을 사용하지 않음)
      localStorage.setItem(popupKey, storageData)
      this.close()
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  flex-direction: column;
  padding-left: 0;
  padding-right: 0;
  z-index: 9999999;
}
</style>
